import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { SmartModalService, ModalSize } from 'src/modules/base/services/smart-modal.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { ModalService } from 'src/modules/base/services/modal.service';
import { QrCodeScannerComponent } from 'src/modules/base/components/qr-code-reader/qr-code-scanner.component';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { ActivatedRoute, Router } from '@angular/router';
import { PrintService } from 'src/modules/base/shared/services/print.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { TokenPopUpViewComponent } from './token-pop-up-view/token-pop-up-view.component';

@Component({
    selector: 'kx-generate-token',
    templateUrl: './generate-token.component.html',
    styleUrls: ['./generate-token.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GenerateTokenComponent implements OnInit {
  result: any; css: any;
  showDetails: boolean = false
  selectedData: any; title_image_id: any;
  showToken: boolean = true
  tokenNumber: any;
  now: any; bg_profile_path = "/dms/api/v1/orgImage/image-response-entity?args=id:";
  disableBtn: boolean = true;
  selectedserviceId: any;
  phoneNumber: any;
  headerInfo: any

  constructor(
    private baseService: BaseService,
    public appService: AppService,
    public modal: SmartModalService,
    private loader: LoaderService,
    private alert: AlertsService,
    private dialogService: DialogService,
    private modalService: ModalService,
    // private smartModalService: SmartModalService,
    public route: ActivatedRoute,
    private renderer: Renderer2,
    public printService: PrintService,
    public communicationService: CommunicationService
  ) {
    setInterval(() => {
      this.now = new Date();
    }, 1);
  }

  ngOnInit() {
    this.headerInfo = this.appService;
    this.hasBackgroundcolor();
    this.baseService.setTitle("menu.generate_token");
    this.getLocationdata();
  }

  getLocationdata() {
    this.baseService.get("GET_BY_ID", "id:" + this.route.snapshot.queryParams.key, "queue_location", "facility-management").subscribe((result: any) => {
      if (result.errCode === 0 && result?.resource?.length) {

        this.css = result.resource[0] && result.resource[0].css ? result.resource[0].css : "";
        if (this.css) {
          const style = this.renderer.createElement('style');
          style.textContent = this.css;
          this.renderer.appendChild(document.head, style);
        }
        this.title_image_id = result.resource[0] && result.resource[0].title_image_id ? this.bg_profile_path + result.resource[0].title_image_id : "";
      } else {
        // this.alert.error(result.message)
      }
    })
    let location_code = this.route?.snapshot?.queryParams?.location_code
    this.locationWiseQueue(location_code)
    this.checkSidebarOpen();

  }

  locationWiseQueue(location_code?) {
    var filter = ""
    if (location_code) {
      filter = "status:active" + ",location_code:" + location_code
    } else {
      filter = "status:active"
    }
    this.baseService.get("GET_DISTINCT_DISPLAY_NAME", "", "display_name_master", "facility-management", filter).subscribe((res: any) => {
      if (res && res.resource && res.resource.length > 0) {
        this.result = res.resource.map(x => { return { ...x, logo_profile_path: x.logo_id ? this.bg_profile_path + x.logo_id : "" } });
      }
    })
  }


  ngOnDestroy() {
    // let showbody: HTMLElement = document.getElementsByTagName("body")[0] as HTMLElement
    // showbody.style.backgroundImage = "";
    // let hasColor: HTMLElement = document.getElementsByClassName("main")[0] as HTMLElement
    // hasColor.style.margin = null;
    // hasColor.style.width = null;
    // let hasDisplay: HTMLElement = document.getElementsByTagName("app-header")[0] as HTMLElement
    // hasDisplay.style.display = "block"
    this.checkSidebarOpen(true)
  }

  hasBackgroundcolor() {
    let hasColor: HTMLElement = document.getElementsByClassName("main")[0] as HTMLElement
    hasColor.style.margin = "0";
    hasColor.style.width = "100%";
    document.getElementsByTagName("body")[0].style.backgroundImage = "linear-gradient(270deg, #0b5695, #003b6c)";
    // let hasDisplay: HTMLElement = document.getElementsByTagName("app-header")[0] as HTMLElement
    // hasDisplay.style.display = "none"
    // document.getElementsByTagName("app-header")[0]['style'].display = "none"
  }

  openAppointment(data: any) {
    this.selectedData = data;
    this.showDetails = true;
    this.showToken = true;
    this.disableBtn = false;
    this.selectedserviceId = data.id;
    let hasDisplay: HTMLElement = document.getElementById("r") as HTMLElement
    hasDisplay.scrollIntoView();
  }

  submitData(res: any, noPhone: boolean = false) {
    if (!noPhone) {
      if (!this.phoneNumber) {
        this.alert.error("Please enter mobile no first");
        return
      }

      if (!JSON.stringify(this.phoneNumber).match(this.appService._currentSessionData.mobilePattern ? this.appService._currentSessionData.mobilePattern : '^[0-9+]{10,12}$')) {
        this.alert.error("Mobile no is not Valid")
        return
      }
    }

    if (this.disableBtn) {
      this.alert.error("Please select a service or enter valid mobile number");
      return
    }
    this.loader.showSpinner()
    var resource = {
      user_role: this.selectedData.user_role,
      user_role_id: this.selectedData.id,
      walkinPatient: noPhone || res.target.value != 'yes',
      mobile_number: noPhone ? "" : this.phoneNumber,
      department_id: "",
      department_name: "",
      service_id: this.selectedserviceId == "" ? this.selectedData.id : this.selectedserviceId,
      token_service: this.selectedData.display_name,
      service_date: new Date().setHours(0, 0, 0, 0),
      "prefix": this.selectedData.code ? this.selectedData.code : '',
    }
    this.baseService.action(resource, 'Add', 'queue-management', 'token_master').subscribe((res: any) => {
      if (res.resource) {
        this.loader.hideSpinner()
        // this.showToken = false;
        this.disableBtn = true;
        this.phoneNumber = "";
        this.tokenNumber = res.resource[0].token;
        if (res.resource[0].mobile_number) {
          this.alert.successWithMessage('', `Token No. ${this.tokenNumber} is sent to your entered mobile no ${res.resource[0].mobile_number.split("").map((x,index)=> { if(index < 6){ return "x"}else {return x}}).join("")}.`)
        } else {
          this.alert.successWithMessage('', `Token No. ${this.tokenNumber} generated.`)
        }
        this.hideName();
        this.openPopup(res.resource[0]);
        this.selectedData = "";
      } else {
        this.loader.hideSpinner()
        this.alert.error(res.message)
      }
    })
  }

  getTokenWithoutPhone(event: any) {
    this.checkServiceSelection();
    if (!this.selectedData) {
      return
    }
    this.modalService.confirm("Generate Token", "You are generating a token without a phone number. Continue?", ModalSize.Sm).subscribe((confirmed: any) => {
      if (confirmed) {
        this.submitData(event, true);
      }
    });
  }

  hideName() {
    const that = this;
    setTimeout(function () {
      // debugger;
      that.showToken = true;
      that.selectedserviceId = "";
    }, 5000);
  }

  checklength(event, value) {
    if (value.length <= 12)
      if (event.key.toLowerCase() == "e") {
        return false
      }
  }

  hasQrCodeScanner() {
    let popobj = { data: {}, title: 'QR Code Scanner', size: DialogModalSize.Sm };
    this.dialogService.open(QrCodeScannerComponent, popobj).afterClosed.subscribe(
      response => {
        if (response) {
          if (response && response.uhId != undefined && response.uhId) {
            this.getPatientDetail(response)
          } else {
            this.alert.error("The QR code does not contain a valid UHID. Please try again")
          }
        }
      });
  }
  getPatientDetail(result) {
    let gridData = {
      "args": "uhId:" + result.uhId,
      "query_id": 'GET_PATIENT_BY_ID_OR_UHID'
    }
    this.baseService.getWithPage(gridData, "patient", "patient-registration", "GET_PATIENT_BY_ID_OR_UHID").subscribe(
      (response) => {
        if (response.resource && response.resource.length > 0) {
          this.phoneNumber = Number(response.resource[0].telecom)
          this.loader.hideSpinner();
        } else {
          this.loader.hideSpinner();
        }
      },
      (err: any) => {
        console.log("An error occurred while processing the QR code. Please try again.", err);
        this.loader.hideSpinner();
      }
    );
  }

  checkServiceSelection() {
    if (this.result && this.result.length == 1) {
      this.selectedData = this.result[0];
      this.showDetails = true;
      this.showToken = true;
      this.disableBtn = false;
      this.selectedserviceId = this.result[0].id;
      return;
    }
    if (!this.selectedData) {
      this.alert.error("Please make sure to choose a service to continue.");
    }
  }


  openPopup(data?) {
    // this.modalService.confirmCustomBtn("field.label.thank_you", "Your token number is " + this.tokenNumber, ModalSize.Sm, { ok: "Print", cancel: "OK" }).subscribe(result => {
    //   if (result) {
    //     this.getTokenPrint(data)
    //   }
    // });
    let token = { "generateToken": true, "message": data.mobile_number
      ? `Token No. ${this.tokenNumber} is sent to your mobile no ${data.mobile_number.split("").map((x,index)=> { if(index < 6){ return "x"}else {return x}}).join("")}.`
      : `Token No. ${this.tokenNumber} generated.` };
    this.modal.open(TokenPopUpViewComponent, token, "", ModalSize.Md, "hide", "token-alert-popup").subscribe((result: any) => {
      if (result) {
        this.getTokenPrint(data)
      }
    });

  }




  getTokenPrint(obj, callback = null) {
    this.loader.showSpinner();
    let file_data = {
      template: "GetTokenPrint",
      resource: "token_master",
      args: "id:" + obj.id,
      application: "queue-management",
      file_type: "pdf",
      contentType: "pdf",
    }
    this.baseService.handleFile(file_data, (fileData) => {
      if (fileData) {
        file_data['key'] = obj.id;
        this.printService.handleFileReponse(file_data, 'print', fileData, callback);
      } else {
        this.alert.error('server error');
      }
      this.loader.hideSpinner();
    })

  }

  checkSidebarOpen(destroy = false): void {
    const header = document.getElementsByTagName('app-header')?.[0] as HTMLElement | null;
    const mainContainer = document.getElementsByClassName('main')?.[0] as HTMLElement | null;
    const coreBody = document.getElementById('core-body');
    if (!header || !mainContainer) return;
    // Update sidebar state
    this.communicationService.emitSidebar({ sidebar: destroy });
    // Toggle header visibility
    header.style.display = destroy ? 'block' : 'none';
    // Update main container styles when destroying
    if (destroy) {
      mainContainer.style.margin = null;
      mainContainer.style.width = null;
    }
    // Update body margin styles if core-body exists
    if (coreBody) {
      const marginTop = destroy ? '55px' : '0px';
      const style = document.createElement('style');
      style.textContent = `.header-fixed .app-body { margin-top: ${marginTop} !important; overflow-x: hidden !important; }`;
      document.head.appendChild(style);
    }
  }
}
